import { COLORS } from '../../../models/colors.types';
import { POSITIONS_HORIZONTAL } from '../../../models/positions.types';

export const VISUAL_TAGS = {
  titleHuge: 'title-huge',
  title3xl: 'title-3xl',
  title2xl: 'title-2xl',
  titleXl: 'title-xl',
  titleLg: 'title-lg',
  titleMd: 'title-md',
  titleSm: 'title-sm',
  displayHuge: 'display-huge',
  display3xl: 'display-3xl',
  display2xl: 'display-2xl',
  displayXl: 'display-xl',
  displayLg: 'display-lg',
  displayMd: 'display-md',
  displaySm: 'display-sm',
} as const;
export type VisualTitleHtmlTag = (typeof VISUAL_TAGS)[keyof typeof VISUAL_TAGS];

export const TITLE_SIZES = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  div: 'div',
  span: 'span',
} as const;
export type TitleSize = (typeof TITLE_SIZES)[keyof typeof TITLE_SIZES];

export const TITLE_SPACINGS_Y = {
  default: 'default',
  top: 'top',
  bottom: 'bottom',
  none: 'none',
} as const;
export type TitleSpacingY = (typeof TITLE_SPACINGS_Y)[keyof typeof TITLE_SPACINGS_Y];

export const TITLE_ALIGNMENTS = {
  left: POSITIONS_HORIZONTAL.left,
  center: POSITIONS_HORIZONTAL.center,
  right: POSITIONS_HORIZONTAL.right,
} as const;
export type TitleAlignment = (typeof TITLE_ALIGNMENTS)[keyof typeof TITLE_ALIGNMENTS];

export const TITLE_COLORS = {
  default: COLORS.default,
  subtle: COLORS.subtle,
  subtlest: COLORS.subtlest,
  inverse: COLORS.inverse,
  accent: COLORS.accent,
} as const;
export type TitleColors = (typeof TITLE_COLORS)[keyof typeof TITLE_COLORS];
